import {AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {MarkerComponent} from '@mydocma/tile-viewer/lib/pin/marker-component';
import {Pin} from '@mydocma/tile-viewer';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'mydocma-click-sync-marker',
  templateUrl: './click-sync-marker.component.html',
  styleUrls: ['./click-sync-marker.component.scss']
})
export class ClickSyncMarkerComponent implements OnInit, AfterViewInit, OnChanges, MarkerComponent {
  @ViewChild('elemRef') elemRef: ElementRef;
  @Input() rotation = 0;
  draggable = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.updateMarkerRotation(this.rotation);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.rotation) {
      this.updateMarkerRotation(changes?.rotation.currentValue ?? 0);
    }
  }

  attachToPin(pin: Pin): any {
  }

  public updateMarkerRotation(rotationValue: number) {
    if (this.elemRef?.nativeElement) {
      this.elemRef.nativeElement.style.transform =
        `rotate(${-rotationValue + 90}deg)`;
    }
  }
}
